import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "edit",
  "use": "edit-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"edit\"><path d=\"M23.86 3.06A4.13 4.13 0 0 0 17 1.21L2.19 16 0 24l8-2.19L22.79 7.05a4.15 4.15 0 0 0 1.07-3.99zm-2.59 2.46L6.91 19.88l-3.84 1.05 1.05-3.84L18.48 2.73a2 2 0 0 1 1.9-.51 2 2 0 0 1 1.4 1.4 2 2 0 0 1-.51 1.9z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol